//
// Software Name: Orange Design System Charts
// SPDX-FileCopyrightText: Copyright (c) 2023 - 2026 Orange SA
// SPDX-License-Identifier: MIT
//
// This software is distributed under the MIT license.
//
export const DEFAULT_LINES_AXIS = {
    categoryAxis: {
        axisLine: {
            show: true,
            lineStyle: {
                color: 'var(--bs-border-color-subtle, #ccc)',
            },
        },
        axisLabel: {
            show: true,
            color: 'var(--bs-body-color, #000000)',
        },
        axisTick: {
            show: false,
            lineStyle: {
                color: 'var(--bs-border-color-subtle, #cccccc)',
            },
        },
    },
    valueAxis: {
        axisLine: {
            show: true,
            lineStyle: {
                color: 'var(--bs-border-color-subtle, #cccccc)',
            },
        },
        axisLabel: {
            show: true,
            color: 'var(--bs-body-color, #000000)',
        },
        axisTick: {
            show: false,
            lineStyle: {
                color: 'var(--bs-border-color-subtle, #cccccc)',
            },
        },
    },
    logAxis: {
        axisLine: {
            show: true,
            lineStyle: {
                color: 'var(--bs-border-color-subtle, #cccccc)',
            },
        },
        axisLabel: {
            show: true,
            color: 'var(--bs-body-color, #000000)',
        },
        axisTick: {
            show: false,
            lineStyle: {
                color: 'var(--bs-border-color-subtle, #cccccc)',
            },
        },
    },
    timeAxis: {
        axisLine: {
            show: true,
            lineStyle: {
                color: 'var(--bs-border-color-subtle, #cccccc)',
            },
        },
        axisLabel: {
            show: true,
            color: 'var(--bs-body-color, #000000)',
        },
        axisTick: {
            show: false,
            lineStyle: {
                color: 'var(--bs-border-color-subtle, #cccccc)',
            },
        },
    },
};
